module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('list-manage', {
    attrs: {
      "title": "分类",
      "max": 100,
      "prevent-back": !!_vm.selection,
      "selection": _vm.selection,
      "data": _vm.tags
    },
    on: {
      "back": function($event) {
        _vm.$emit('back')
      },
      "add": _vm.add,
      "update": _vm.update,
      "remove": _vm.remove,
      "select": function (args) { return _vm.$emit('select', args); }
    }
  }, [_c('p', {
    staticClass: "t-c",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("暂时还没有分类哦，请先添加一个吧")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4cfd0564","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Tags.vue
// module id = 233
// module chunks = 1